const PREFIX = 'admin';

export const statisticApi = api => ({
  getStoreQrScannedStatistics(storeId) {
    return api.get(`/${PREFIX}/statistics/get/qrScanned/${storeId}`);
  }
});
